<template lang="pug">
  div.welfare-header-container
    .header-content
      //- 积分信息（左侧）
      PointsInfo(
        :points="points"
        :bounty="bounty"
        :bountyLoaded="bountyLoaded"
      )

      //- 气泡组件（右侧）
      HeaderBubbles(
        :rewardCount="rewardCount"
        :isDueSoon="isDueSoon"
        :signExtInfo="signExtInfo"
        @awardClick="handleAwardClick"
        @signBubbleClick="handleSignBubbleClick"
      )
</template>

<script>
import PointsInfo from './points-info';
import HeaderBubbles from './header-bubbles';

export default {
  name: 'WelfareHeader',
  components: {
    PointsInfo,
    HeaderBubbles,
  },
  props: {
    points: {
      type: Number,
      default: 0,
    },
    bounty: {
      type: Number,
      default: 0,
    },
    // 单单返币奖励金数量
    rewardCount: {
      type: Number,
      default: 0,
    },
    // 单单返奖励金是否即将过期
    isDueSoon: {
      type: Boolean,
      default: false,
    },
    // 奖励金加载状态
    bountyLoaded: {
      type: Boolean,
      default: false,
    },
    // 签到扩展信息
    signExtInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // 点击单单返奖励
    handleAwardClick() {
      this.$emit('awardClick');
    },
    // 点击签到气泡（透传至 index 展示签到弹窗）
    handleSignBubbleClick() {
      this.$emit('signBubbleClick');
    },
  },
};
</script>

<style lang="less" scoped>
.welfare-header-container {
  padding: 0 0.12rem;

  .header-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.14rem 0.06rem;
    height: 0.68rem;
  }
}
</style>
